import { Components, Theme } from '@mui/material';
import { ButtonSize } from '../../model';

/**
 * Padding applied to the IconButton based on the size prop provided.
 */
export const iconButtonPadding: Record<ButtonSize, number> = {
  small: 4,
  medium: 6,
};

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * IconButton to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/icon-button/#css
 */
export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      // This is common for all variants
      borderRadius: theme.shape.borderRadius,

      // MUI doesn't have variants of IconButton like we do in the design system,
      // but its default rendering appearance is closest to our "secondary"
      // variant, so these styles are for our "secondary" variant
      // TODO: styles from designers once they have them for this variant
    }),

    sizeSmall: {
      padding: iconButtonPadding.small,
    },

    sizeMedium: {
      padding: iconButtonPadding.medium,
    },
  },
};
